import { Text } from "@fluentui/react";
import { DocumentBulletList24Regular } from "@fluentui/react-icons";

import styles from "./SummaryButton.module.css";

interface Props {
    className?: string;
    onClick: () => void;
    disabled?: boolean;
    textOverride?: string;
    linkMode?: boolean;
}

const userLanguage = navigator.language;
let summary_text = '';
if (userLanguage.startsWith('pt')) {
  summary_text = 'Resumir publicações/estudos';
} else if (userLanguage.startsWith('es')) {
  summary_text = 'Resumir publicaciones/estudios';
} else {
  summary_text = 'Resumir publicaciones/estudios';
}

export const SummaryButton = ({ className, disabled, onClick, textOverride, linkMode }: Props) => {
    return (
        <div className={`${styles.container} ${className ?? ""} ${disabled && styles.disabled} ${linkMode ? styles.linkMode : ""} `} onClick={disabled ? undefined : onClick}>
            {!linkMode && <DocumentBulletList24Regular className={styles.icon} />}
            <Text variant="medium" className={styles.text}>{textOverride || summary_text}</Text>
        </div>
    );
};
